const he =
{
  "ok": "אשר",
  "cancel": "בטל",
  "delete": "מחק",
  "add_points_button": "עדכן",
  "add_person": "הוסף ילד",
  "delete_line": "מחק חשבון!",
  "add_person_title": "הוסף שם ילד",
  "add_points": "\\u00B1 נקודות",
  "add_note": "הוסף הערה",
  "history_point_add": "הוספו:",
  "history_point_request": "נקודות מבוקשות:",
  "history_point_before": "לפני הוספה",
  "history_note": "הערה:",
  "focus_show_history": "הצג היסטוריה",
  "share_score": "שתף חשבון",
  "share_type": "סוג שיתוף",
  "note_hint": "הקלד הערה",
  "notificaton_title": "נקודות עודכנו",
  "notification_content": "בדוק עדכונים",
  "read_only": "עם ילד( קריאה בלבד)",
  "read_and_write": "עם הורה( קריאה וכתיבה)",
  "signed_out": "סטטוס: מנותק",
  "sign_out": "צא",
  "send_message": "שלח מסר",
  "disconnect": "התנתק",
  "loading": "טוען",
  "delete_score": "מחק חשבון",
  "channel_name": "עדכוני חשבון",
  "channel_description": "עדכונים אודות שינויי חשבון",
  "score_change_notification_title": "עדכון חשבון",
  "score_shared_with_you": "שיתף",
  "google_title_text": "התחבר עם חשבון גוגל",
  "remove_ads": "הסר מודעות",
  "remove_ads_title": "הסר מודעות",
  "purchase": "קניה",
  "please_wait": "אנא המתן",
  "product_purchased": "המוצר נרכש",
  "product_not_purchased": "המוצר לא נרכש",
  "shared_description": "משותף",
  "changed_by": "שונה ע\"י:",
  "sign_in_cancelled": "התחברות בוטלה",
  "no_internet_connection": "לא מחובר לאינטרנט",
  "unknown_error": "שגיאה לא ידועה",
  "log_off": "התנתק",
  "named_login_button": "התחבר ע\"מ לאבטח מידע",
  "approve_log_off": "אשר היתנתקות",
  "log_in": "התחבר",
  "recycle_bin": "מיחזור",
  "recycle_title": "מיחזור",
  "clear_recycle_bin": "נקה סל מיחזור",
  "invite_text": "הנך מוזמן לשיתוף בחשבון. הקש:",
  "invite_mail_title": "Invite from Points-O-Rama",
  "chooser_title": "שתף",
  "history_header": "היסטוריית חשבון:",
  "rename_account": "שנה שם",
  "start_handling_link": "מתחיל לטפל בהזמנה. אנא המתן.",
  "link_handling_fail": "הזמנה נכשלה! כנראה הופעלה כבר בעבר.",
  "camera_button_text": "Camera button",
  "history_image_large": "תמונה מהיסטוריית חשבון",
  "request_button": "בקש",
  "move_to_recyclebin_notice": "מעביר חשבון לסל המיחזור.",
  "rate_this_app": "דרג וסקור"
}

export default he;



// WEBPACK FOOTER //
// ./src/i18n/translations/he.js